import axios, { AxiosRequestConfig } from '@bt/web-api-request';
import { Toast } from 'vant';
import * as API from '@/api';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

const service = axios.create({
  baseURL: process.env.VUE_APP_ROUTER_BASE_URL,
  withCredentials: true,
  timeout: 30000,
});

const pkg = require('../../../../package.json');

service.interceptors.request.use(
  config => {
    if (pkg) {
      config.headers['x-version'] = `${pkg.name}:v${pkg.version}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    const data = response.data || {};
    if (!data.code) {
      return data;
    }
    if (data.code === 401 || data.code === 402) {
      // 鉴权未通过
      return Promise.reject(data);
    } else if (data.code !== 200) {
      if (data.code !== 410) { // 登录错误不tip提示
        Toast.fail(data.msg || '服务端错误！');
      }
      return Promise.reject(data);
    }
    return data.res;
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '请求错误';
          break;
        case 401:
          err.message = '未授权，请登录';
          break;
        case 403:
          err.message = '拒绝访问';
          break;
        case 404:
          err.message = `请求地址出错: ${err.response.config.url}`;
          break;
        case 408:
          err.message = '请求超时';
          break;
        case 409:
          err.message = '键值冲突';
          break;
        case 417:
          err.message = '参数缺失';
          break;
        case 500:
          err.message = '服务器内部错误';
          break;
        case 501:
          err.message = '服务未实现';
          break;
        case 502:
          err.message = '网关错误';
          break;
        case 503:
          err.message = '服务不可用';
          break;
        case 504:
          err.message = '网关超时';
          break;
        case 505:
          err.message = 'HTTP版本不受支持';
          break;
        default:
      }
    }
    if (err.message !== 'Network Error' && err.code !== 410) {
      Toast.fail(err.message || '网络异常！');
    }
    return Promise.reject(err);
  },
);

async function getMojaveToken(forceNew = false) {
  let token = forceNew ? '' : localStorage.getItem('mojaveToken');
  if (!token) {
    token = await API.getMojaveToken();
    if (token) {
      localStorage.setItem('mojaveToken', token);
    }
  }
  return token;
}

async function getDataInMojave(requestConfig: any, forceNew = false) {
  const token = await getMojaveToken(forceNew);
  const config = {
    baseURL: process.env.VUE_APP_MOJAVE_BASE_API,
    headers: {'authorization': `Bearer ${token}`}
  };
  if (requestConfig.headers) {
    Object.assign(config.headers, requestConfig.headers);
    delete requestConfig.headers;
  }
  return service.request(Object.assign(config, requestConfig));
}

export function getWxConfig() {
  return service.request({
    baseURL: '/',
    url: `/wx/js-config?url=${encodeURIComponent(location.href)}`,
    method: 'get',
  });
}

export const request = {
  async get <T = any>(url: string, params?: object, config: AxiosRequestConfig = {}) {
    const data = await service.get<T>(url, {params, ...config});
    return data as any as T;
  },
  async post<T = any>(url: string, data?: object, config?: AxiosRequestConfig) {
    const res = await service.post<T>(url, data, config);
    return res as any as T;
  },
  async put<T = any>(url: string, data?: object, config?: AxiosRequestConfig) {
    const res = await service.put<T>(url, data, config);
    return res as any as T;
  },
  async delete<T = any>(url: string, config?: AxiosRequestConfig) {
    const res = await service.delete(url, config);
    return res as any as T;
  },
  async patch<T = any>(url: string, data?: object, config?: AxiosRequestConfig) {
    const res = await service.patch<T>(url, data, config);
    return res as any as T;
  },
  async throughApi<T = any>(servicePath: string, params?: object, config: { isAuth?: boolean, authKey?: string } = {}) {
    const res = await service.throughApi<T>(
      servicePath,
      params,
      {url: `${process.env.VUE_APP_BASE_API}/through-api`, ...config}
    );
    return res as any as T;
  },
  async throughMojaveApi<T = any>(requestConfig: AxiosRequestConfig) {
    let response;
    try {
      response = await getDataInMojave(requestConfig, false);
    } catch (e) {
      console.log('e---------', e.message);
      if (e.code === 410 || e.message === "Failed to execute 'setRequestHeader' on 'XMLHttpRequest': Value is not a valid ByteString.") { // 失败后重试一次
        localStorage.removeItem('mojaveToken');
        try {
          response = await getDataInMojave(requestConfig, true);
        } catch (e) {
          return Promise.reject(Object.assign(new Error(response.msg), response));
        }
      } else {
        return Promise.reject(Object.assign(new Error(response.msg), response));
      }
    }
    console.log('response', response);
    return response as any as T;
  },
};

export default service;
